"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function () {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const features = [{
    number: "01",
    title: "TRASPARENZA DEI COSTI",
    description: "Nessun costo nascosto. Ogni preventivo include materiali, chirurgo e assistenza, garantendo chiarezza totale prima del viaggio."
  }, {
    number: "02",
    title: "CERTIFICAZIONE MATERIALI",
    description: "Utilizziamo esclusivamente impianti Nobel Biocare e Alpha Bio originali, dotati di passaporto implantare e garanzia internazionale."
  }, {
    number: "03",
    title: "PROTOCOLLI DI SICUREZZA",
    description: "Standard igienico-sanitari europei rigorosi, con monitoraggio costante della sterilizzazione e tracciabilità completa dei dispositivi medici."
  }, {
    number: "04",
    title: "ASSISTENZA DEDICATA",
    description: "Un tutor italiano ti seguirà in ogni fase: dalla pianificazione del viaggio fino al post-operatorio, per la tua massima tranquillità."
  }];
  return <section data-section-id="4610" id="dataprivacytransparency" className="bg-slate-50 text-slate-900 relative overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-screen">
        {}
        <div ref={imageRef} className={`relative h-[60vh] lg:h-auto overflow-hidden transition-all duration-1000 ease-out ${imageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663456/img/dental_transparency_clinic.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663456/img/dental_transparency_clinic.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663456/img/dental_transparency_clinic.webp-wvc-sizes" alt="Studio dentistico moderno e luminoso con attrezzature all'avanguardia" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />
          {}
          <div className="absolute inset-0 bg-gradient-to-br from-slate-50/40 via-transparent to-slate-50/60" />

          {}
          <div aria-hidden="true" className="absolute left-[-20%] top-1/2 w-[140%] h-px" style={{
          transform: "rotate(30deg)",
          background: "var(--primary)",
          boxShadow: "0 0 12px var(--primary), 0 0 24px var(--primary)",
          opacity: 0.85
        }} />

          {}
          <div className="absolute bottom-8 left-8 font-mono text-xs tracking-widest" style={{
          color: "var(--muted-foreground)"
        }}>
            <span style={{
            color: "var(--primary)"
          }}>●</span> GUIDA / ALBANIA 2026
          </div>
        </div>

        {}
        <div ref={contentRef} className={`relative flex items-start py-20 lg:py-[120px] px-6 sm:px-10 lg:pl-[80px] xl:pl-[120px] lg:pr-12 transition-all duration-1000 ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="hidden lg:block absolute left-6 top-[120px] origin-top-left">
            <div className="font-mono text-[11px] tracking-[0.3em] whitespace-nowrap" style={{
            writingMode: "vertical-rl",
            transform: "rotate(180deg)",
            color: "var(--muted-foreground)"
          }}>
              GUIDA IMPLANTOLOGIA / SEZIONE 02
            </div>
          </div>

          <div className="w-full max-w-2xl">
            {}
            <div className="lg:hidden mb-6 font-mono text-[11px] tracking-[0.3em]" style={{
            color: "var(--muted-foreground)"
          }}>
              GUIDA IMPLANTOLOGIA / 02
            </div>

            {}
            <h2 className="font-default font-bold leading-[0.95] tracking-tighter text-5xl sm:text-6xl lg:text-7xl xl:text-[6rem] uppercase">
              <span className="block">Trasparenza</span>
              <span className="block">e Sicurezza</span>
              <span className="block">
                Clinica
                <span style={{
                color: "var(--primary)",
                textShadow: "0 0 18px var(--primary)"
              }}>.</span>
              </span>
            </h2>

            {}
            <p className="font-default mt-8 text-lg sm:text-[19px] leading-relaxed max-w-[460px]" style={{
            color: "var(--muted-foreground)"
          }}>
              La nostra missione è guidare i pazienti italiani verso scelte consapevoli. Analizziamo ogni aspetto 
              della cura dentale in Albania, garantendo standard di eccellenza, materiali certificati e 
              protocolli clinici che superano le aspettative.
            </p>

            {}
            <ul className="mt-14 border-t" style={{
            borderColor: "var(--border)"
          }}>
              {features.map((feature, i) => <li data-index={i} key={feature.number} className="group relative border-b py-7 grid grid-cols-[auto_1fr] gap-x-6 sm:gap-x-10 items-start cursor-default" style={{
              borderColor: "var(--border)"
            }}>
                  {}
                  <span aria-hidden="true" className="absolute left-0 top-0 bottom-0 w-[2px] opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{
                background: "var(--primary)",
                boxShadow: "0 0 10px var(--primary), 0 0 20px var(--primary)"
              }} />

                  <span className="font-mono text-xs tracking-widest pt-1" style={{
                color: "var(--muted-foreground)"
              }}>
                    {feature.number}
                  </span>

                  <div className="pl-4 sm:pl-6">
                    <h3 className="font-default font-bold text-lg sm:text-xl tracking-tight uppercase text-slate-900">
                      {feature.title}
                    </h3>
                    <p className="font-default mt-2 text-base sm:text-[17px] leading-relaxed" style={{
                  color: "var(--muted-foreground)"
                }}>
                      {feature.description}
                    </p>
                  </div>
                </li>)}
            </ul>

            {}
            <div className="mt-12">
              <Button asChild size="lg" className="font-default font-bold uppercase tracking-widest text-sm h-14 px-8 shadow-lg hover:shadow-xl transition-shadow" style={{
              background: "var(--primary)",
              color: "var(--primary-foreground)",
              boxShadow: "0 0 24px hsla(217, 91%, 60%, 0.35), var(--shadow-2xl)"
            }}>
                <Link to="/AboutUsPage">
                  Scopri il Metodo
                  <ArrowRight className="ml-1 h-4 w-4" />
                </Link>
              </Button>

              <div className="mt-6 font-mono text-[11px] tracking-[0.25em]" style={{
              color: "var(--muted-foreground)"
            }}>
                CONSULENZA GRATUITA <span style={{
                color: "var(--primary)"
              }}>—</span> DISPONIBILE ORA
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}